import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { ManageUsersBanks } from "../../ManageUsersBanks";

export interface Props extends RouteComponentProps<{ userEmail: string }> {}

export class AdminManageUsersBanks extends Component<Props, {}> {
  render() {
    return (
      <ManageUsersBanks
        isAdminMode={true}
        history={this.props.history}
        location={this.props.location}
        match={this.props.match}
      />
    );
  }
}
